import { ChangeDetectionStrategy, Component, EventEmitter, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EservicesDetailsComponent } from '../../../../../eservices/eservices-details/eservices-details.component';

export interface EserviceDetailDialogData {
  item: any;
  onSave: EventEmitter<any>;
}

@Component({
  selector: 'app-eservice-detail-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, EservicesDetailsComponent],
  templateUrl: './eservice-detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EserviceDetailDialogComponent {
  readonly dialogRef = inject(MatDialogRef<EserviceDetailDialogComponent>);
  readonly data = inject<EserviceDetailDialogData>(MAT_DIALOG_DATA);
}
